import { useProductData } from "../../../../hooks/useProductData";
import { useConsumablesProductDetailsContext } from "../../../../providers/ConsumablesProductDetailsProvider";
export const useConsumablesProductData = () => {
    const { currentMatrixItem } = useConsumablesProductDetailsContext();
    const consumablesProductData = useProductData({
        sku: currentMatrixItem.sku,
        currentVariantSku: currentMatrixItem.sku,
    });
    return consumablesProductData;
};
//# sourceMappingURL=useConsumablesProductData.js.map